
import { supabase } from '@/integrations/supabase/client';

export const authService = {
  async signIn(email: string, password: string) {
    console.log('🔐 [AuthService] Sign in attempt:', email);
    
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(),
      password,
    });
    
    if (error) {
      console.error('❌ [AuthService] Sign in error:', error);
      throw error;
    }
    
    console.log('✅ [AuthService] Sign in successful');
    return { user: data.user, error: null };
  },

  async signOut() {
    console.log('🚪 [AuthService] Signing out...');

    const { error } = await supabase.auth.signOut();

    if (error) {
      console.error('❌ [AuthService] Sign out error:', error);
      throw error;
    }

    try {
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.includes('supabase') || key.includes('sb-'))) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));
    } catch (e) {
      console.warn('Could not clear localStorage:', e);
    }

    try {
      const sessionKeys: string[] = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && (key.includes('supabase') || key.includes('sb-'))) {
          sessionKeys.push(key);
        }
      }
      sessionKeys.forEach(key => sessionStorage.removeItem(key));
    } catch (e) {
      console.warn('Could not clear sessionStorage:', e);
    }

    console.log('✅ [AuthService] Sign out successful');
  },

  async getSession() {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('❌ [AuthService] Get session error:', error);
        throw error;
      }
      
      return session;
    } catch (error) {
      console.error('❌ [AuthService] Get session failed:', error);
      throw error;
    }
  },

  onAuthStateChange(callback: (event: string, session: any) => void) {
    return supabase.auth.onAuthStateChange(callback);
  }
};
